// react
import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// ui icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import CalendarToday from "@material-ui/icons/CalendarToday";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Assignment from "@material-ui/icons/Assignment";
import Healing from "@material-ui/icons/Healing";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";

// core components
import CustomTabs from "beaktShared/components/CustomTabs/CustomTabs.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

import GestaoClienteForm from "./GestaoClienteForm.js";
import GestaoAgenda from "beaktDay/views/AdminAgenda/Agenda/GestaoAgenda.js";
import GestaoVendas from "beaktMatriz/views/Vendas/GestaoVendas.js";
import GestaoClienteAvaliacao from "./GestaoClienteAvaliacao.js";
import GestaoClienteProntuarioList from './GestaoClienteProntuarioList.js';
import GestaoAnamneseList from "./GestaoAnamneseList.js";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.js";
import { transformValueFormatedtoFloat } from 'beaktShared/helpers/masks.js';

const useStyles = makeStyles(wizardStyle);

export default function GestaoCliente({ addItem, item, handleView, loading, estabelecimentoId }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const [bloqueiaCPFeNOME, setbloqueiaCPFeNOME] = React.useState(true);
  const [disabledCPF, setdisabledCPF] = React.useState(true);
  const [disabledNOME, setdisabledNOME] = React.useState(true);
  const [disabledEMAIL, setdisabledEMAIL] = React.useState(true);
  const [disableMedicalRecord, setDisableMedicalRecord] = React.useState(false);
  const [disableAnamnese, setDisableAnamnese] = React.useState(false);

  useEffect(() => {
    UseGetApiSimple("Franquias/GetByEstabelecimento/" + session.estabelecimentoId).then((result) => {
      if (result.status == 200) 
      {
        const bLayoutAnamnese = result.data.layoutAnamneseId !== null;
        setDisableMedicalRecord(result.data.habilitaProntuario);
        setDisableAnamnese(bLayoutAnamnese);
      }
    });

  }, []);

  return ( 
      <div className="maxContent" style={{position:'relative'}}>

        <Button onClick={() => handleView(true)} 
        style={{position:'absolute',right:'30px',top:'-10px',zIndex:'4',color:'white'}} >
          <ArrowBack className={classes.icons} />  {t('label.return')}
        </Button> 
        <CustomTabs
            title=""
            headerColor="primary"
            tabs={[
              {
                tabName: t('information_message.form'),
                tabIcon: PermIdentity,
                tabContent: (
                  <div>
                    <br/>
                  <GestaoClienteForm addItem={addItem} item={item} handleView={handleView} loading={loading} estabelecimentoId={estabelecimentoId} disabledNOME={disabledNOME} disabledCPF={disabledCPF} disabledEMAIL={disabledEMAIL} />
                  </div>
                )
              },
              {
                tabName: t('information_message.schedules'),
                tabIcon: CalendarToday,
                tabContent: (
                  <GestaoAgenda clienteId={item.clienteId} handleView={handleView} />    
                )
              },
              {
                tabName: t('information_message.sales'),
                tabIcon: ShoppingCart,
                tabContent: (
                  <GestaoVendas clienteId={item.clienteId} estabelecimentoId={estabelecimentoId} BtnFinalizaVenda={true} />   
                )
              },
              {
                tabName: t('information_message.avaliations'),
                tabIcon: Assignment,
                tabContent: (
                  <GestaoClienteAvaliacao clienteId={item.clienteId} estabelecimentoId={estabelecimentoId} />
                )
              },
              {
                tabName: t('information_message.medical_records'),
                tabIcon: Healing,
                tabVisible: disableMedicalRecord,
                tabContent: (
                  <GestaoClienteProntuarioList clienteId={item.clienteId} estabelecimentoId={estabelecimentoId} />
                )
              },
              {
                tabName: t('information_message.anamnesis'),
                tabIcon: AssignmentTurnedIn,
                tabVisible: disableAnamnese,
                tabContent: (
                  <GestaoAnamneseList clienteId={item.clienteId} estabelecimentoId={estabelecimentoId} />   
                )
              },
            ]}
          />

      </div>
  );
}